import React from "react";
import { displayIcon } from "variables/icons";
import { Badge } from "antd";

const TabLabel = ({ text, count=null, icon=null, bgColor="white" }) => (
    <div className="flex items-center justify-center gap-2">
		{icon && displayIcon(icon, "h-4 w-4")}
      	<span className="text-sm font-medium">{text}</span>
	  	{count && 
			<Badge
				count={count}
				style={{
					backgroundColor: bgColor === "red" ? "#ff0000" : "#fff",
					color: bgColor === "red" ? "#fff" : "#000",
					border: "1px solid #d9d9d9",
				}}
			/>
		}
    </div>
);

export default TabLabel;
